import React from "react";
import { Container, Stack, Typography, Grid } from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import moment from "moment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const RegManagerCard = ({
  fullName,
  category,
  subCategory,
  clickHandler,
  id,
}) => {
  //   const date = moment(fromDate).utc().format("MMMM Do, YYYY");
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      onClick={() => clickHandler(id)}
    >
      {/* <Grid item sm={1}></Grid> */}
      <Grid item sm={2} style={{ display: "flex", justifyContent: "center" }}>
        <AccountCircleIcon
          style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
        />
      </Grid>
      <Grid item sm={8}>
        <Typography style={{ fontWeight: "bold", textTransform: "capitalize" }}>
          {fullName}
        </Typography>
        <Typography className="mb-10">
          {`${category} | ${subCategory}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default RegManagerCard;
